import { Component, OnInit, Compiler, ViewChild, ElementRef } from '@angular/core';
import { first, retry } from 'rxjs/operators';
import { Router } from '@angular/router';
import { ErrorComponent } from '../confirm/error.component';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA  } from '@angular/material/dialog';
import { FormBuilder, Validators, FormControl } from '@angular/forms';
import { NgbDatepickerConfig } from '@ng-bootstrap/ng-bootstrap';
import { AppConfig } from '../util';
import { CommonService } from '../service/commons-service';
import { Common } from '../util/common';

@Component({ templateUrl: './tower.component.html', styleUrls: ['./tower.component.css'] })
export class TowerComponent implements OnInit {

  @ViewChild('closeModel', {read: ElementRef}) closeModel: ElementRef;
   users: any = {};
   towerForm: any;
   config: any;
   ibuInfoList: any[] = [];
   towerInfoList: any[] = [];
   submitted = false;
   loginImageURL: any = "";
   loginUserName: any = "";
   baseURL: any = null;
   showHideModel: boolean = true;
   loading: boolean = false;
   activeUserCount: number = 0;
   inactiveUserCount: number = 0;
   towerId: any;
   towerName: any;
   superUserType: any = "";
   dtOptions: any = {ordering: false};
  functionList: any = [];
   selectedIbuId: any = 1;
   selectedFunctionId: any = 1;


  constructor(private modalService: MatDialog,
    private router: Router,
    private formBuilder: FormBuilder,
    private commonService: CommonService,
    private appConfig: AppConfig,
    config: NgbDatepickerConfig,
    private common: Common,
    private _compiler: Compiler) {
    this._compiler.clearCache();
    this.users = JSON.parse(localStorage.getItem('user'));
    if (!this.users || !this.users.userData) {
      this.commonService.logout
      return;
    }
    if (this.users && this.users.userData) {
      this.loginImageURL = this.users.userData.imageURL;
      this.loginUserName = this.users.userData.userFullName;
      this.towerId = this.users.userData.towerId;
      this.towerName = localStorage.getItem('towerName');
    }
    if (localStorage.getItem('superUserType')) {
      this.superUserType = localStorage.getItem('superUserType');
    }
    let currentDate = new Date();
    this.config = config;
    this.config.minDate = { year: currentDate.getFullYear() - 10, month: currentDate.getMonth(), day: currentDate.getDate() };
    this.config.maxDate = { year: 2099, month: 12, day: 31 };
    this.config.markDisabled = false;
    this.initUserInfo();
  }

  //initailised user form
  ngOnInit() {
    this.towerForm = this.formBuilder.group({
      towerName: ['', Validators.required],
      functionId: [null, Validators.required],
      ibuId: new FormControl("Select BU"),
    });
    // Get IBU Id List.
    this.getFunctionList();
    this.initialization();
  }

  //initial setup level assets
  private initialization() {
    if (this.superUserType == "super") {
      this.getAllTowsersInfo();
      this.getAllIBUInfo();
    } else {
      this.getTowerInfoByIbuId();
      this.getAllIBUInfoByIbuId();
    }

  }

  //reset user form
   initUserInfo() {
    this.towerForm = this.formBuilder.group({
      towerName: ['', Validators.required],
      functionId: [null, Validators.required],
      ibuId: new FormControl("Select IBU"),
    });
  }
  //reset user form 
  private setUpdateUserInfo(towerInfo) {
    this.selectedIbuId = towerInfo.ibuId;
    this.initUserInfo();
    this.getFunctionList();
    this.towerForm = this.formBuilder.group({
      towerId: new FormControl(towerInfo.towerId),
      towerName: new FormControl(towerInfo.towerName),
      ibuId: new FormControl(towerInfo.ibuId),
      functionId: new FormControl(towerInfo.functionId),
    });
  }

  //Get All user list
  private getAllIBUInfo() {
    this.loading = true;
    this.ibuInfoList = [];
    this.commonService.getAllIBUInfo().pipe(first()).subscribe(
      data => {
        this.ibuInfoList = data;
        this.loading = false;
      },
      error => {
        this.loading = false;
        localStorage.setItem('errorMsg', error.statusText);
        this.showerror();
      }
    )
  }

  //Get tower info by towerId
  private getTowerInfoByIbuId() {
    this.loading = true;
    this.towerInfoList = [];
    // this.commonService.getTowerInfoByIbuId(this.towerId).pipe(first()).subscribe(
    this.commonService.getTowerList().pipe(first()).subscribe(
      data => {
        this.towerInfoList = data;
        this.loading = false;
      },
      error => {
        this.loading = false;
        localStorage.setItem('errorMsg', error.statusText);
        this.showerror();
      }
    )
  }

  //Get All user list
  private getAllIBUInfoByIbuId() {
    this.loading = true;
    this.ibuInfoList = [];
    this.commonService.getAllIBUInfoByIbuId(this.towerId).pipe(first()).subscribe(
      data => {
        this.ibuInfoList = data;
        this.loading = false;
      },
      error => {
        this.loading = false;
        localStorage.setItem('errorMsg', error.statusText);
        this.showerror();
      }
    )
  }

  // Get ibu name based on ibuId
  private getIBUName(ibuId) {
    let ibuName = "";
    for (let i = 0; i < this.ibuInfoList.length; i++) {
      if (this.ibuInfoList[i].ibuId == ibuId) {
        ibuName = this.ibuInfoList[i].ibuName;
        break;
      }
    }
    return ibuName;
  }



  //Get all accounts info
  private getAllTowsersInfo() {
    this.loading = true;
    this.towerInfoList = [];
    this.commonService.getTowerList().pipe(first()).subscribe(
      data => {
        this.towerInfoList = data;
        this.loading = false;
      },
      error => {
        this.loading = false;
        localStorage.setItem('errorMsg', error.statusText);
        this.showerror();
      }
    )
  }

  // Save new user profile
  private onSubmit(towerInfo) {
    if (this.towerForm.invalid) {
      this.submitted = true;
      return;
    } else {
      if (towerInfo.ibuId == "Select IBU") {
        localStorage.setItem('errorMsg', 'Must Select BU!');
        this.showerror();
        return;
      } else if (towerInfo.functionId == "" || towerInfo.functionId == null) {
        localStorage.setItem('errorMsg', 'Must Select function!');
        this.showerror();
        return;
      }
      // check tower name is already exits
      if (this.checkTowerName(towerInfo.towerName)) {
        localStorage.setItem('errorMsg', towerInfo.towerName + ' tower already exits!');
        this.showerror();
        return;
      }
      this.loading = true;
      //set login user email
      this.commonService.saveTowerInfo(towerInfo).pipe(first()).subscribe(
        data => {
          this.loading = false;
          this.towerForm.reset();
          this.initialization();
          localStorage.setItem('errorMsg', 'Tower Added successfully!');
          this.showerror();
        },
        error => {
          this.loading = false;
          localStorage.setItem('errorMsg', 'Must enter all the fields!');
          this.showerror();
        }
      )
    }
  }

  // update user profile 
  private updateTowerInfo(towerInfo) {
    if (this.towerForm.invalid) {
      localStorage.setItem('errorMsg', 'Please enter user information!');
      this.showerror();
      return
    }
    if (towerInfo != null) {
      if (towerInfo) {
        // // check tower name is already exits
        // if (this.checkTowerName(towerInfo.towerName)) {
        //   localStorage.setItem('errorMsg', towerInfo.towerName + ' tower already exits!');
        //   this.showerror();
        //   return;
        // }
        this.loading = true;
        this.commonService.updateTowerInfo(towerInfo).pipe(first()).subscribe(
          data => {
            this.loading = false;
            this.initialization();
            this.closeModels();
            localStorage.setItem('errorMsg', 'Tower is updated successfully!');
            this.showerror();
          },
          error => {
            this.loading = false;
            localStorage.setItem('errorMsg', error.statusText);
            this.showerror();
          }
        )
      }
    }
  }

  // Delete user profile
  private onDeleteSubmit(userInfo) {
    this.loading = true;
    //set login user email
    this.commonService.userDeletion(userInfo).pipe(first()).subscribe(
      data => {
        this.loading = true;
        this.initialization();
        localStorage.setItem('errorMsg', 'Tower is deleted successfully!');
        localStorage.removeItem('errorMsg');
        this.showerror();
      },
      error => {
        this.loading = false;
        localStorage.setItem('errorMsg', error.statusText);
        this.showerror();
      }
    )
  }

  // check tower name is already exits
  private checkTowerName(towerName) {
    let isTowerNameExits = false;
    for (let i = 0; i < this.towerInfoList.length; i++) {
      if (towerName.toLowerCase() == this.towerInfoList[i].towerName.toLowerCase()) {
        isTowerNameExits = true;
        break;
      }
    }
    return isTowerNameExits;
  }

  //show dailog box for user messages
  showerror() {
    const modal = this.modalService.open(ErrorComponent, {
      width: 'auto',
      data: { title: 'Confirm title', message: 'Confirm message' }
    });
  }

  //close dailog box
  private closeModels() {
    this.closeModel.nativeElement.click();
  }


  /**
     * Get the function list
     */
  getFunctionList() {
    this.loading = true;
    this.functionList = [];
    this.commonService.getFunctionListByIbuId(this.selectedIbuId).subscribe(data => {
      this.loading = false;
      this.functionList = data;
    },
      error => {
        this.loading = false;
        console.log('Error in function list');
      });
  }
  /**
     * Set Ibu Id.
     */
  private onChangeIbu() {
    this.selectedFunctionId = null;
    this.getFunctionList();
  }

}
